import React from 'react';
import ReactDOM from 'react-dom';
import Preview from './App/Preview';

window.Preview = Preview;
window.React = React;
window.ReactDOM = ReactDOM;



// WEBPACK FOOTER //
// ./app/javascript/packs/preview.jsx